<template>
  <v-layout
    row
    wrap
    style="padding: 0 0  0 20px; "
  >
    <!-- <v-flex
      xs4
      4
    >
      <v-dialog
        ref="dialogStartDate"
        v-model="modalStartDate"
        :return-value.sync="editTMP.StartDate"
        persistent
        full-width
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="editTMP.StartDate"
            :label="$t('menus.availability.startDate')"
            prepend-icon="mdi-calendar-clock"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="editTMP.StartDate"
          :locale="locale"
          scrollable
          dark
          @input="handleEmit"
        >
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="modalStartDate = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialogStartDate.save(editTMP.StartDate)"
          >
            {{ $t('common.ok') }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex
      xs4
      4
    >
      <v-dialog
        v-if="!editTMP.NoEndDate"
        ref="dialogEndDate"
        v-model="modalEndDate"
        :return-value.sync="editTMP.EndDate"
        persistent
        full-width
        width="290px"
      >
        <template
          v-slot:activator="{ on }"
        >
          <v-text-field
            v-model="editTMP.EndDate"
            :label="$t('menus.availability.endDate')"
            prepend-icon="mdi-calendar-clock"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="editTMP.EndDate"
          scrollable
          dark
          @input="handleEmit"
        >
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="modalEndDate = false"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialogEndDate.save(editTMP.EndDate)"
          >
            {{ $t('common.ok') }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex
      xs4
      4
      style="padding-left: 10px;"
    >
      <v-checkbox
        v-model="editTMP.NoEndDate"
        :label="$t('menus.availability.noEndDate')"
        @change="handleEmit"
      />
    </v-flex> -->
    <!-- ---------------------------------------------------------- -->
    <v-layout wrap align-center>      
      <v-flex xs3 style="text-align: right;padding-right:10px;">
        <b>{{$t('availability.periodicity')}}:</b>
      </v-flex>
      <v-flex xs9>
        <v-radio-group v-model="per" row @change="handleChangeIsModified">
          <v-radio :label="$t('availability.allDays')" :value="0"></v-radio>
          <v-radio :label="$t('availability.oneDay')" :value="1"></v-radio>
          <v-radio :label="$t('availability.recurrence')" :value="2"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12>
        <v-checkbox
          @change="handleChangeIsModified"
          v-model="isAllTimes"
          :value="isAllTimes"
          :label="$t('availability.isAllTimes')"
        />
      </v-flex>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs6>
            <v-dialog
              ref="dialogDateStart"
              v-model="modalDateStart"
              :return-value.sync="dateStart"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateStart"
                  :label="per !== 1 ? $t('availability.dateStart') : $t('availability.date')"
                  prepend-icon="mdi-calendar-clock"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                @change="handleChangeIsModified"
                v-model="dateStart"
                :locale="locale"
                scrollable
                dark
                @input="handleChangeIsModified"
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="modalDateStart = false"
                >
                  {{ $t('common.cancel') }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="handleSaveDateStart(dateStart)"
                >
                  {{ $t('common.ok') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6 v-if="!isAllTimes">
            <interval-times
              :label="`${$t('availability.timeStart')}:`"
              v-model="timeStart"
              @input="handleChangeIsModified"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs6>
            <v-checkbox
              v-if="per !== 1"
              v-model="isAllDays"
              :value="isAllDays"
              :label="$t('availability.noEndDay')"
              @change="handleChangeIsModified"
            />
            <v-dialog
              v-if="!isAllDays && per !== 1"
              ref="dialogDateEnd"
              v-model="modalDateEnd"
              :return-value.sync="dateEnd"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateEnd"
                  :label="$t('availability.dateEnd')"
                  prepend-icon="mdi-calendar-clock"
                  readonly
                  v-on="on"
                  @change="handleChangeIsModified"
                />
              </template>
              <v-date-picker
                v-model="dateEnd"
                :locale="locale"
                scrollable
                dark
                @input="handleChangeIsModified"
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="modalDateEnd = false"
                >
                  {{ $t('common.cancel') }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="handleSaveDateEnd(dateEnd)"
                >
                  {{ $t('common.ok') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6 v-if="!isAllTimes">
            <interval-times
              :label="`${$t('availability.timeEnd')}___:`"
              v-model="timeEnd"
              @input="handleChangeIsModified"
            />
          </v-flex>
        </v-layout>
      </v-flex>
       <v-flex xs3 style="text-align: right;padding-right:10px;" v-if="per===2">
        <b>{{$t('availability.recurrence')}}:</b>
      </v-flex>
      <v-flex xs9 v-if="per===2">
        <v-radio-group v-model="rec" row @change="handleChangeIsModified">
          <v-radio :label="$t('availability.byWeek')" :value="1"></v-radio>
          <v-radio :label="$t('availability.byMonth')" :value="0"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 v-if="per===2 && rec===0">
        <b>{{$t('availability.byMonth')}}:</b>
        <v-container row>
          <v-checkbox
            v-model="dayOfMonth"
            v-for="(day, indexDayOfMonth) in 31"
            :key="`dayOfMonth${indexDayOfMonth}`"
            :label="indexDayOfMonth+1"
            :value="indexDayOfMonth+1"
            style="width:50px;margin-right: 20px;"
            @change="handleChangeIsModified"
            multiple
          />
        </v-container>
      </v-flex>
      <v-flex xs12 v-if="per===2 && rec===1">
        <b>{{$t('availability.byWeek')}}:</b>
        <v-container row>
          <v-checkbox
            v-model="dayOfWeek"
            v-for="(day, indexDayOfweek) in 7"
            :key="`dayOfWeek${indexDayOfweek}`"
            :label="$t(`common.s${indexDayOfweek}`)"
            :value="indexDayOfweek === 6 ? 0 : indexDayOfweek+1"
            style="width:100px;margin-right: 20px;"
            @change="handleChangeIsModified"
            multiple
          />
        </v-container>
      </v-flex>
      <v-flex xs12 v-if="per===2">
        <v-text-field
            :label="$t('availability.alternation')"
            outlined
            v-model="alt"
            @input="handleChangeIsModified"
          />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import CustomTimePicker from '@/components/CustomTimePicker'
  import IntervalTimes from '@/components/intervalTimes/Index'
  export default {
    components: {
      CustomTimePicker,
      IntervalTimes
    },
    props: {
      editTMP: {
        type: Object,
        require: true
      },
      onChange: {
        type: Function,
        required: true        
      }
    },
    data () {
      return {
        modalStartDate: false,
        modalEndDate: false,

        per: 0,
        dateStart: new Date().toISOString().split('T')[0],
        dateEnd: new Date().toISOString().split('T')[0],
        timeStart: 120,
        timeEnd: 120,
        isAllTimes: true,
        isAllDays: true,
        rec: 1,
        dayOfWeek: [],
        dayOfMonth: [],
        alt: 1,

        modalDateStart: false,
        modalDateEnd: false
      }
    },
    computed: {
      ...mapState('app',['locale']),
    },
    mounted () {
      console.log('jhm1111', this.editTMP.Availability, this.editTMP.IsTemp)
      const availability = this.editTMP.Availability
      if (availability && this.editTMP.IsTemp) {
        this.per = availability.Per
        this.dateStart = availability.DateStart.split('T')[0],
        this.dateEnd = availability.DateEnd.split('T')[0],
        this.timeStart = availability.TimeStart
        this.timeEnd = availability.TimeEnd
        this.isAllTimes = availability.IsAllTimes
        this.isAllDays = availability.IsAllDays
        this.rec = availability.Rec
        // this.dayOfWeek = JSON.parse(availability.DayOfWeek)
        // this.dayOfMonth = JSON.parse(availability.DayOfMonth)
        this.dayOfWeek = availability.DayOfWeek
        this.dayOfMonth = availability.DayOfMonth
        this.alt = availability.Alt
      }
    },
    methods: {
      handleEmit () {
        this.$store.state.app.isModified = true
      },
      handleSaveDateEnd(value) {
        this.$refs.dialogDateEnd.save(value)
        this.handleChangeIsModified()
      },
      handleSaveDateStart(value) {
        this.$refs.dialogDateStart.save(value)
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
        this.onChange({
            IsTemp: this.isTemp,
            Per: this.per,
            DateStart: this.dateStart,
            DateEnd: this.dateEnd,
            TimeStart: this.timeStart,
            TimeEnd: this.timeEnd,
            IsAllTimes: this.isAllTimes,
            IsAllDays: this.isAllDays,
            Rec: this.rec,
            DayOfWeek: this.dayOfWeek,
            DayOfMonth: this.dayOfMonth,
            Alt: this.alt
          })
      }
    }
  }
</script>
